
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#d20311","stroke-width":"0px"},attrs:{"d":"m15,8c-.27,0-.52-.11-.71-.29L8.29,1.71c-.39-.39-.39-1.02,0-1.41.39-.39,1.02-.39,1.41,0l6,6c.39.39.39,1.02,0,1.41-.19.19-.44.29-.71.29Z"}}),_c('path',{staticStyle:{"fill":"#d20311","stroke-width":"0px"},attrs:{"d":"m9,14c-.27,0-.52-.11-.71-.29-.39-.39-.39-1.02,0-1.41l6-6c.39-.39,1.02-.39,1.41,0,.39.39.39,1.02,0,1.41l-6,6c-.19.19-.44.29-.71.29Z"}}),_c('path',{staticStyle:{"fill":"#d20311","stroke-width":"0px"},attrs:{"d":"m15,8H1c-.55,0-1-.45-1-1s.45-1,1-1h14c.55,0,1,.45,1,1s-.45,1-1,1Z"}})])
          )
        }
      }
    